import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

export const more = {
  icon: 'plus',
  text: 'More',
};
export const less = {
  icon: 'minus',
  text: 'Less',
};

export default function MoreLessButton(props) {
  const {
    tagsCount,
    expandSearchOptions,
    onToggleSearchOptions,
  } = props;

  if (tagsCount <= 1) {
    return null;
  }

  const { icon, text } = expandSearchOptions ? less : more;


  return (
    <Button
      onClick={onToggleSearchOptions}
      buttonConfig={{
        label: text,
        type: 'link',
        size: 'sm',
        className: 'tree-view-dialog-selected-search-items-more-less-button',
        e2eName: 'more-less',
      }}
      iconConfig={{ name: icon, size: 'sm' }}
    />
  );
}


MoreLessButton.propTypes = {
  tagsCount: PropTypes.number.isRequired,
  expandSearchOptions: PropTypes.bool.isRequired,
  onToggleSearchOptions: PropTypes.func.isRequired,
};
